import type { ChangeEvent, FC } from 'react';
import { useCallback } from 'react';

import FormField, { type FormFieldProps } from './FormField';

const formatRut = (raw: string): string => {
  const cleaned = raw.replace(/[^0-9kK]/g, '').toUpperCase();
  if (cleaned.length <= 1) return cleaned;
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);
  const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${withDots}-${dv}`;
};

interface RutFieldProps extends Omit<FormFieldProps, 'value' | 'onChange' | 'type'> {
  value: string;
  onChange: (value: string) => void;
}

const RutField: FC<RutFieldProps> = ({
  value,
  onChange,
  label = 'RUT',
  placeholder = 'Ej: 12.345.678-9',
  hint,
  error,
  ...rest
}) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChange(formatRut(e.target.value));
    },
    [onChange]
  );

  return (
    <FormField
      {...rest}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      hint={hint}
      error={error}
      slotProps={{
        ...rest.slotProps,
        htmlInput: {
          ...((typeof rest.slotProps?.htmlInput === 'object' && rest.slotProps?.htmlInput) || {}),
          inputMode: 'text',
          maxLength: 12,
        },
      }}
    />
  );
};

export default RutField;
